import { Injectable, Inject } from '@angular/core';
import { MwLocaleService } from '@core/services';
import * as moment from 'moment';
import {
  MW_DATE_RANGE_PICKER_LOCALE_CONFIG,
  DateRangePickerLocaleConfig,
  DefaultDateRangePickerLocaleConfig,
} from './@models/date-range-picker.locale-config';

@Injectable()
export class MwDateRangePickerLocaleService {
  private defaultConfig: DateRangePickerLocaleConfig;

  constructor(
    @Inject(MW_DATE_RANGE_PICKER_LOCALE_CONFIG)
    private localConfig: DateRangePickerLocaleConfig,
    private localeService: MwLocaleService
  ) {
    this.defaultConfig = DefaultDateRangePickerLocaleConfig;
    this.refreshNamesByLocale();

    this.localeService.onLocaleChanged.subscribe(() =>
      this.refreshNamesByLocale()
    );
  }

  get config(): DateRangePickerLocaleConfig {
    if (!this.localConfig) {
      return this.defaultConfig;
    }

    return { ...this.defaultConfig, ...this.localConfig };
  }

  private refreshNamesByLocale(): void {
    this.defaultConfig = {
      ...this.defaultConfig,
      daysOfWeek: moment.weekdaysMin(),
      monthNames: moment.months(),
      firstDay: moment.localeData().firstDayOfWeek(),
    };
  }
}
